// Numer rachunku nabywcy (NRB). Kopia functions/shared/nrb.js - aplikacja
// React nie moze importowac spoza src/. Przy zmianie poprawic oba miejsca.
//
// Po co: wgranie umowy nie zapisywalo rachunku nabywcy, a bez niego wplaty
// z banku nie przypinaja sie do lokalu (Szczecin, 04.11.2026: 3,2 mln zl).

export const cyfryNrb = (wartosc) =>
  String(wartosc || '').toUpperCase().replace(/^\s*PL/, '').replace(/[^0-9]/g, '');

const cyfryKontrolne = (bban24) => {
  let r = 0;
  for (const ch of `${bban24}252100`) r = (r * 10 + Number(ch)) % 97;
  return String(98 - r).padStart(2, '0');
};

export const formatujNrb = (wartosc) => {
  const c = cyfryNrb(wartosc);
  return `${c.slice(0, 2)} ${c.slice(2).replace(/(\d{4})(?=\d)/g, '$1 ')}`.trim();
};

export const sprawdzNrb = (wartosc) => {
  const c = cyfryNrb(wartosc);
  if (!c) return { ok: false, powod: 'pusty' };
  if (c.length !== 26) return { ok: false, powod: `numer ma ${c.length} cyfr zamiast 26` };
  if (cyfryKontrolne(c.slice(2)) !== c.slice(0, 2)) return { ok: false, powod: 'bledne cyfry kontrolne' };
  return { ok: true, cyfry: c, sformatowany: formatujNrb(c) };
};
